export default "__VITE_PUBLIC_ASSET__91cf87ba__"